import { useState } from "react";

export default function CTASection() {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      // Placeholder — wire to real mailing list endpoint when ready
      await new Promise(resolve => setTimeout(resolve, 800));
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setSubmitting(false);
  };

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, #1E3A8A 0%, #1D4ED8 40%, #0D9488 100%)" }} />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full"
          style={{ background: "radial-gradient(circle, white 0%, transparent 70%)" }} />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full"
          style={{ background: "radial-gradient(circle, white 0%, transparent 70%)" }} />
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold text-white/80 border border-white/20 bg-white/10 mb-6 tracking-widest">
          GET STARTED TODAY
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
          Ready to transform<br />your payments?
        </h2>
        <p className="text-lg text-white/70 mb-10 max-w-xl mx-auto leading-relaxed">
          Join thousands of businesses already using Paygent to power their payment infrastructure. Start building for free.
        </p>

        {submitted ? (
          <div className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-white/20 border border-white/30">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-400">
              <i className="ri-check-line text-white w-5 h-5 flex items-center justify-center" />
            </div>
            <span className="text-white font-semibold">You&apos;re on the list! We&apos;ll be in touch soon.</span>
          </div>
        ) : (
          <form

            id="cta-contact-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your work email"
              className="flex-1 px-5 py-3.5 rounded-xl border border-white/30 bg-white/10 text-white placeholder-white/50 focus:outline-none focus:border-white/60 text-sm"
            />
            <button
              type="submit"
              disabled={submitting}
              className="px-7 py-3.5 rounded-xl text-blue-700 font-semibold text-sm bg-white hover:bg-blue-50 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-70"
              style={{ boxShadow: "0 4px 16px rgba(0,0,0,0.15)" }}
            >
              {submitting ? "Sending..." : "Start for free"}
            </button>
          </form>
        )}

        <p className="text-white/50 text-xs mt-4">No credit card required. Free plan available.</p>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 mt-14 pt-10 border-t border-white/20">
          {[
            { value: "$50B+", label: "Payment volume processed" },
            { value: "150+", label: "Countries supported" },
            { value: "99.99%", label: "Platform uptime SLA" },
          ].map((stat) => (
            <div key={stat.value}>
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-white/60">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
